<template>
  <div v-show="hidShow">
    <div style="height:60px;"></div>
    <div class="mobile_nav">
      <el-row>
        <el-col :span="8">
          <div id="0" @click="checkNav" :class="['nav',activeId == 0 ?'mob-nav-active':'']" style>
            <i style="font-size:18px;" class="el-icon-s-home pointer-none"></i>
            首页
          </div>
        </el-col>
        <el-col :span="8">
          <div
            id="1"
            @click="checkNav"
            :class="['nav',activeId == 1 ?'mob-nav-active':'']"
            class="nav"
          >
            <i class="el-icon-search f18 pointer-none"></i>高级检索
          </div>
        </el-col>
        <!-- <el-col :span="6">
        <router-link to="/">分类</router-link>
        </el-col>-->
        <el-col :span="8">
          <div
            id="2"
            @click="checkNav"
            :class="['nav',activeId == 2 ?'mob-nav-active':'']"
            class="nav"
          >
            <i class="el-icon-user f18 pointer-none"></i>个人
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: function() {
    return {
      // activeId: this.$store.state.activeId
      docmHeight: document.documentElement.clientHeight, // 默认屏幕高度
      showHeight: document.documentElement.clientHeight, // 实时屏幕高度
      hidShow: true // 显示或者隐藏footer
    };
  },
  computed: mapState({
    activeId: "activeId"
  }),
  mounted: function() {
    console.log(this.showHeight)
    let vm = this;
    // window.resize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight;
      })();
    };
  },
  watch: {
    showHeight: function() {
      console.log(this.docmHeight)
      if (this.docmHeight > this.showHeight) {
        this.hidShow = false;
      } else {
        this.hidShow = true;
      }
    }
  },
  methods: {
    checkNav: function(e) {
      // alert(1)
      this.$store.state.activeId = e.target.id;
      if (e.target.id == 0) {
        console.log(this.activeId);
        this.$router.push("/");
      } else if (e.target.id == 1) {
        console.log(this.activeId);
        this.$router.push("/highsearch");
      } else {
        console.log(this.activeId);
        this.$router.push("/personinfo");
        console.log("/personinfo");
      }
    }
  },
  watch:{
    
  }
};
</script>

<style lang="scss">
/* // 底部导航栏 */
.mobile_nav {
  position: fixed;
  width: 100%;
  bottom: 0px;
  z-index: 999;
  text-align: center;
  background-color: #fff;
  border-top: 1px solid #dddddd;
  // height: 60px;
  // line-height: 60px;
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      .nav {
        display: flex;
        flex-direction: column;
        vertical-align: middle;
        align-items: center;
        justify-content: center;
        padding: 10px;
      }
    }
  }
  .mob-nav-active {
    color: #00aaff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer/mfooter.vue